import { Grid, Paper } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2.5),
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    boxShadow: 'none',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.5),
  },
  chip: {
    padding: theme.spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    marginTop: '4px',
    borderRadius: '10.0px',
    '@media only screen and (max-width:768px)': { padding: theme.spacing(2) },
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    },
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  profileSection: {
    display: 'flex',
  },
  profileInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: theme.spacing(2),
  },
  menuButton: {
    margin: '0px 3px',
    alignSelf: 'baseline',
    borderRadius: '20px',
    border: '1px solid #C0D9FF',
    backgroundColor: '#F3F7FF',
    width: '26px',
    height: '26px',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
}));

/**
 * Composant skeleton pour CardCandidat pendant le chargement des données.
 * Reproduit fidèlement la structure et les dimensions du composant principal.
 *
 * @returns {JSX.Element} Le composant skeleton avec la structure de CardCandidat
 */
const CardCandidatSkeleton = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={6} lg={3} style={{ padding: '20px 20px 0 0' }}>
      <Paper className={classes.paper}>
        {/* Header avec avatar + nom/ville + menu d'actions */}
        <div className={classes.headerContainer}>
          <div className={classes.profileSection}>
            <Skeleton variant="circle" width={50} height={50} className={classes.skeletonColor} />
            <div className={classes.profileInfo}>
              <Skeleton variant="text" width="140px" height={24} className={classes.skeletonColor} />
              <div className={classes.address}>
                <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor} />
                <Skeleton variant="text" width="100px" height={18} className={classes.skeletonColor} style={{ marginLeft: 16 }} />
              </div>
            </div>
          </div>
          <Skeleton variant="rect" width={26} height={26} className={classes.skeletonColor + ' ' + classes.menuButton} />
        </div>

        {/* Section des informations avec icônes */}
        <div>
          {/* Diplôme */}
          <div className={classes.row}>
            <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="60%" height={18} className={classes.skeletonColor} />
          </div>

          {/* Formation */}
          <div className={classes.row}>
            <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="75%" height={18} className={classes.skeletonColor} />
          </div>

          {/* Type de formation */}
          <div className={classes.row}>
            <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="55%" height={18} className={classes.skeletonColor} />
          </div>

          {/* Localisation */}
          <div className={classes.row}>
            <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="65%" height={18} className={classes.skeletonColor} />
          </div>

          {/* Date de candidature */}
          <div className={classes.row}>
            <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="70%" height={18} className={classes.skeletonColor} />
          </div>

          {/* Chip Profil examiné */}
          <div className={classes.row}>
            <Skeleton
              variant="rect"
              width="45%"
              height={28}
              className={classes.skeletonColor}
              style={{
                borderRadius: '10px',
                marginTop: 4
              }}
            />
          </div>

          {/* Chip Niveau d'intérêt */}
          <div className={classes.row}>
            <Skeleton
              variant="rect"
              width="55%"
              height={28}
              className={classes.skeletonColor}
              style={{
                borderRadius: '10px',
                marginTop: 4
              }}
            />
          </div>

          {/* Chip Statut */}
          <div className={classes.row}>
            <Skeleton
              variant="rect"
              width="40%"
              height={28}
              className={classes.skeletonColor}
              style={{
                borderRadius: '10px',
                marginTop: 4
              }}
            />
          </div>
        </div>

        {/* Bouton "Voir le candidat" */}
        <Skeleton
          variant="rect"
          width="100%"
          height={36}
          className={classes.skeletonColor}
          style={{
            borderRadius: 4,
            marginTop: 8
          }}
        />
      </Paper>
    </Grid>
  );
};

export default CardCandidatSkeleton; 